// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/deep/ #cms-content{padding-top:0!important}h4{font-family:Libre Franklin;font-size:26px!important;font-style:normal;font-weight:500!important;line-height:36px!important;letter-spacing:0;text-align:left}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
